import React, { Component } from "react"
import MetaTags from 'react-meta-tags';

import {
    Col, Container, Row, Card,
    CardBody,
} from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import logodark from "assets/images/logo-dark.png"

class BirthChartPaymentSuccess extends Component {
    constructor(props) {
        super(props)
        this.state = {
            birthDetail: {},
            birthChartId: '',
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
    }

    componentDidMount() {
        console.log("BirthChartPaymentSuccess->componentDidMount->called")
        const {
            match: { params }
        } = this.props
        console.log("BirthChartPaymentSuccess->componentDidMount->called->params: ", params)
        if (params && params.id) {
            this.setState({ birthChartId: params.id })
        }
    }

    handleValidSubmit() {
        console.log("handleValidSubmit->called")
        let birthChartId = this.state.birthChartId
        console.log("handleValidSubmit->birthChartId: ", birthChartId)
        if (birthChartId != null && birthChartId != undefined)
            this.props.history.push("/users-birthchart/" + birthChartId)
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Payment Success | Kattam</title>
                    </MetaTags>
                    <Container fluid className="p-0">
                        <Card>
                            <CardBody>
                                <div className="auth-full-page-content p-md-2 p-2">
                                    <div className="w-100">
                                        <div className="d-flex flex-column h-75">
                                            {/*                                             <div className="mb-4 mb-md-2 text-center">
                                                <img
                                                    src={logodark}
                                                    alt=""
                                                    height="80"
                                                    className="auth-logo-dark"
                                                />

                                            </div> */}
                                            <div className="my-auto">
                                                <div className="text-center">
                                                    <div className="avatar-md mx-auto">
                                                        <div className="avatar-title rounded-circle bg-success">
                                                            <i className="bx bxs-like bx-lg"></i>
                                                        </div>
                                                    </div>

                                                    <div className="mt-1">
                                                        <h1 className="text-success">
                                                            Thank you!  Payment done successfully.
                                                </h1>
                                                        <p className="font-weight-semibold">

                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="mt-1 text-center">
                                                    <p>
                                                        Click the button to view the reports page
                                                <br></br>
                                                    </p>
                                                    <Link
                                                        to="/birthchart-report"
                                                        className="btn btn-success btn-lg waves-effect waves-light mt-2"
                                                        >
                                                        View AI Reports {" "} <i className="bx bxs-receipt" />
                                                        </Link>
                                                </div>
                                            </div>
                                            {/* <div className="mt-4 mt-md-5 text-center">
                                                <p className="mb-0">
                                                                            Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}

                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </div>
            </React.Fragment >
        )
    }
}

export default withRouter(BirthChartPaymentSuccess)
